export default __webpack_public_path__ + "static/media/10.66f9e356.jpg";